import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import * as types from 'constants/actionTypes';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField, FormControl, FormHelperText } from '@mui/material';
class TimePickerInput extends Component {
    constructor(props) {
        super(props);

        if (props.value) {//if store has value relative to this component, initialize the state value
            this.state = {  ...this.state, value: props.value };
        }else{ //in case the store does not have any value for this component, just clear it
            this.state = {  ...this.state, value: null, error: "" };
            this.props.dispatch({ type: types.FORM_INPUT, value: null, name: this.props.name });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value) {
            this.setState({  ...this.state, value: newProps.value });
        } else if (!newProps.value) {
            this.setState({ value: null });
        }

        if (newProps.error && newProps.error !== this.state.error) {
            this.setState({ error: newProps.error });
        }
    }

    onChange = (newValue) => {
        if (newValue && JSON.stringify(newValue) !== "null"){
            this.setState({ value: newValue });
            this.props.dispatch({ type: types.FORM_INPUT, value: dayjs(newValue).format('YYYY-MM-DDTHH:mm:ss'), name: this.props.name });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error: "" }); // Clear Redux error
        } else {
            this.setState({ value: null });
            this.props.dispatch({ type: types.FORM_INPUT, value: null, name: this.props.name });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error: "Invalid Time" }); // Show Redux error
        }
    };

    render() {
        const p = this.props;
        const { error } = { ...p };
        const { value } = this.state || {};

        return (
            <div className="form-group TimePicker">
                <FormControl className={`${p.className} ${error && p.required ? 'error' : ``}`} error={error && error !== "" && p.required} fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                       <TimePicker
                            label={p.floatingLabelText}
                            value={value} // Pass Date object or null
                            onChange={this.onChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    id={p.id}
                                    fullWidth={p.fullWidth || true}
                                    // // helperText={p.hintText}
                                    error={error}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        inputMode: 'numeric', // Allows numeric input only
                                        pattern: '[0-9]*', // Validates numbers only
                                      }}
                                />
                            )}
                        />
                    </LocalizationProvider>
                    {p.required && error ? <FormHelperText style={p.errorStyle}>{error}</FormHelperText> : null}
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    // console.log(props.name, typeof state.form[props.name], state.form[props.name]|| ``)
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name] || '',
    };
    };
export default connect(mapStateToProps)(TimePickerInput);
